import * as ApiModels from '@typings/api-models';
import DefaultAction from './DefaultAction';

type ThisItem = (
  & Parameters<typeof DefaultAction>[0]['item']
  & Pick<ApiModels.Task, 'action'>
);

type Props = {
  item: ThisItem;
  userId: string;
  onClick: () => void;
  enabledActions: ApiModels.Task['action'][];
};

const Action: React.FC<Props> = ({ item, userId, onClick, enabledActions }) => {
  const disabled = !enabledActions.includes(item.action);
  return (
    <DefaultAction
      item={item}
      userId={userId}
      onClick={onClick}
      disabled={disabled}
    />
  );
};

export default Action;
